import React, { useEffect, useState } from "react";
import Tabs from "../../../components/Tabs";
import { useNavigate, useParams } from "react-router-dom";
import Spacer from "../../../components/Spacer";
import { Header } from "../../../components/header";
import { indexStore } from "../../../store/indexStore";
import Visibility from "../../../components/utils/Visibility";
import IsNotActive from "../../../components/IsNotActive/IsNotActive";
import RenderAndLoadingMenuCilrcles from "../../../components/LoadingComponent/RenderAndLoadingMenuCilrcles";
import ProductsListMenu from "../../../components/ProductsListMenu/ProductsListMenu";
import ProductModel from "../../../Models/PorductModel";
import SearchField from "../../../components/Searchfield/ SearchField";
import Iterator from "../../../components/utils/Iterator";
import { Skeleton } from "../../../components/ui/skeleton";
import { DarkModeTogle } from "../../../components/langSelect/DarkModeTogle";
function Menu() {
  const {
    changeCategory,
    categoryId,
    fetchCategoriesAction,
    fetchProductsAction,
    products,
    menus,
    categories,
    selectProductAction,
    Menuloading,
    fetchMenusAction,
    loading,
    categoryLoading,
    fetchPriceOffersProducts,
    popularProducts,
    newProducts,
    priceOffersProducts,
  } = indexStore();

  const params = useParams();
  const paramsRequst = {
    domain: params.domain,
    branch_id: params.branch_id,
    menu_id: params.menu,
  };

  const navigate = useNavigate();

  const [selectedMenu, setSelectedMenu] = useState<number | string | undefined>(
    params.menu
  );
  const productTag = window.location.href.split("/").pop();
  const isShortList = ["popular", "new", "offers"].includes(productTag ?? "");
  const onChange = (index: number, id: number) => {
    const p = {
      ...paramsRequst,
      category_id: id,
    };
    changeCategory(id);
    fetchProductsAction(p);
  };

  useEffect(() => {
    if (menus.length === 0) {
      fetchMenusAction(paramsRequst).then(() => {
        fetchPriceOffersProducts(params);
      });
    }
    if (!isShortList) {
      fetchCategoriesAction(paramsRequst)
        .then((res) => {
          if (categoryId === 0) {
            changeCategory(res[0].id);
            const p = {
              ...paramsRequst,
              category_id: res[0].id,
            };
            fetchProductsAction(p);
          }
        })
        .catch((error) => {
          // Set loading to false in case of an error
        });
    }

    // Scroll to the active element if it exists and menus are not empty
    if (menus.length !== 0 && !isShortList) {
      const activeElement = document.querySelector(".active");
      if (activeElement) {
        activeElement.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest", // Prevents vertical scrolling
        });
      }
    }
    //   setSelectedMenu(menus.filter((e, i) => e.id == selectedMenu)[0]);
  }, [selectedMenu, menus, productTag, isShortList]);

  /////////////////////////////////////////////////////////////////
  const handleSelectChange = (id: number) => {
    changeCategory(0);
    setSelectedMenu(id);
    navigate(`/${params.domain}/${params.branch_id}/${id}`);
  };

  const handelOnClickProduct = (item: ProductModel) => {
    navigate(`${item.id}`);
    selectProductAction(item);
  };

  return (
    <IsNotActive>
      <title>{paramsRequst?.domain?.toUpperCase()}</title>
      <Header
        backgroundColorfull={!loading}
        noBack={false}
        url={`/${params.domain}/${params.branch_id}`}
      />
      <div className="bg-background flex-grow ">
        <RenderAndLoadingMenuCilrcles
          loading={loading}
          menus={menus}
          selectedMenu={isShortList ? productTag : selectedMenu}
          handleSelectChange={(e: any) => handleSelectChange(e)}
        >
          <Spacer height={15} />
          <Visibility visible={!Menuloading}>
            <div className="flex flex-col gap-4 px-4 ">
              <div className="flex gap-2 items-center  ">
                <SearchField />
                <button className="bg-background rounded-full p-3 shadow-md">
                  <DarkModeTogle showText={false} />
                </button>
              </div>
              <Visibility visible={!isShortList}>
                <Tabs
                  data={categories}
                  value={categoryId}
                  onChange={(index: number, id: number) => onChange(index, id)}
                />
              </Visibility>

              <ProductsListMenu
                products={
                  productTag === "popular"
                    ? popularProducts
                    : productTag === "new"
                    ? newProducts
                    : productTag === "offers"
                    ? priceOffersProducts
                    : products
                }
                handelOnClickProduct={handelOnClickProduct}
                loading={isShortList ? loading : categoryLoading}
              />
            </div>
          </Visibility>
          <Visibility visible={Menuloading}>
            <div className="flex flex-col gap-4 px-4">
              <div className="flex gap-2 items-center px-4 ">
                <Skeleton className={"w-full h-11 rounded-full"} />
                <Skeleton className={"w-11 h-11 rounded-full"} />
              </div>
              <div className={`flex gap-3 `}>
                <Iterator
                  data={[1, 2, 3]}
                  render={() => (
                    <div>
                      <Skeleton className={` w-20 h-12 rounded-md   `} />
                    </div>
                  )}
                />
              </div>
            </div>
          </Visibility>
        </RenderAndLoadingMenuCilrcles>
      </div>
    </IsNotActive>
  );
}

export default Menu;
